/*
 * Easify Options (FBT widget) — strips the parentheses Easify hard-codes
 * around companion prices: "($17.99)" → "$17.99". Approved DOM text rewrite
 * (Easify support confirmed no setting exists); the sole non-CSS override.
 * If Easify renames .po-optionItemLabel-price this becomes a no-op and the
 * parentheses simply reappear — nothing breaks.
 * Docs: .scratch/easify-options/spec.md · plan: .scratch/easify-options/assets/plan.md
 */
(function () {
  var SELECTOR = '.easify-product-options .po-optionItemLabel-price';

  function strip(node) {
    var text = node.textContent;
    var stripped = text.replace(/^\s*\(\s*/, '').replace(/\s*\)\s*$/, '');
    if (stripped !== text) node.textContent = stripped;
  }

  function sweep() {
    document.querySelectorAll(SELECTOR).forEach(strip);
  }

  function init() {
    var host = document.querySelector('.easify-product-options');
    if (!host) return;
    sweep();
    /* Easify re-renders prices on every selection change; idempotent
       re-strip keeps the observer from looping on its own writes. */
    new MutationObserver(sweep).observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
